import { BrandBar } from 'common/components/brand-bar';
import { StoreContext } from '../../../lib/store';
import { useContext } from 'react';
import * as React from 'react';
import style from './styles.scss';

export function Component() {
  const defaultPosition: number = 4;
  const store = useContext(StoreContext);
  const { formatConfig, creativeStore } = store;
  const { brand, closeBtn } = formatConfig;

  const brandBarPosition: React.CSSProperties = {
    left: closeBtn?.position === 'left' ? 'auto' : defaultPosition,
    right: closeBtn?.position === 'right' ? 'auto' : defaultPosition
  };

  const brandBarStyle: React.CSSProperties = {
    maxWidth: 100
  };

  return (
    <div className={style.brandBarPosition} style={brandBarPosition}>
      <BrandBar
        image={brand?.logo}
        name={!creativeStore.isVertical ? brand?.name : undefined}
        style={brandBarStyle}
        position={closeBtn.position}
      />
    </div>
  );
}
